const _fotos_cies_2019 = () => [
  {
    photo: "055A7601.JPG",
    pathmin: "https://drive.google.com/file/d/1eUTf4hpXmS5yIP4ag3K5iiEkxfAED-14/view",
    path: "",
    id: "1eUTf4hpXmS5yIP4ag3K5iiEkxfAED-14"
  },
  {
    photo: "055A7606.JPG",
    pathmin: "https://drive.google.com/file/d/1PECZlX23-iBChLfnp_KgcfrJuV5a8iGA/view?usp=sharing",
    path: "",
    id: "1PECZlX23-iBChLfnp_KgcfrJuV5a8iGA"
  },
  {
    photo: "055A7608.JPG",
    pathmin: "https://drive.google.com/file/d/13Kx_ZrBK5AepnXd5yrRwoRkULxk3AAEu/view?usp=sharing",
    path: "",
    id: "13Kx_ZrBK5AepnXd5yrRwoRkULxk3AAEu"
  },
  {
    photo: "055A7609.JPG",
    pathmin: "https://drive.google.com/file/d/15L2UM0NwHSoQ8xTI7lJ6FJJl6WPvtIXp/view?usp=sharing",
    path: "",
    id: "15L2UM0NwHSoQ8xTI7lJ6FJJl6WPvtIXp"
  },
  {
    photo: "055A7611.JPG",
    pathmin: "https://drive.google.com/file/d/1j2cQbmVLLxbUVmIhAYn8YpOGbpu2tDfE/view?usp=sharing",
    path: "",
    id: "1j2cQbmVLLxbUVmIhAYn8YpOGbpu2tDfE"
  },
  {
    photo: "055A7615.JPG",
    pathmin: "https://drive.google.com/file/d/1RDd8JZDJTES5LW90W7xGgFWwHCrA4Iqs/view?usp=sharing",
    path: "",
    id: "1RDd8JZDJTES5LW90W7xGgFWwHCrA4Iqs"
  },
  {
    photo: "055A7616.JPG",
    pathmin: "https://drive.google.com/file/d/1-Um6RXQbiUHbkEf4xJEMFEq2UwQ3Vd9E/view?usp=sharing",
    path: "",
    id: "1-Um6RXQbiUHbkEf4xJEMFEq2UwQ3Vd9E"
  },
  {
    photo: "055A7617.JPG",
    pathmin: "https://drive.google.com/file/d/1syGF-SAXbkssD81SyE1fn0Nnd8Umoeav/view?usp=sharing",
    path: "",
    id: "1syGF-SAXbkssD81SyE1fn0Nnd8Umoeav"
  },
  {
    photo: "055A7618.JPG",
    pathmin: "https://drive.google.com/file/d/12pYE5z4MQNJ_IZiVeJGDvciVBX3cW28l/view?usp=sharing",
    path: "",
    id: "12pYE5z4MQNJ_IZiVeJGDvciVBX3cW28l"
  },
  {
    photo: "055A7619.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7626.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7627.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7629.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7631.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7632.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7633.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7638.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7639.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7640.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7646.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7648.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7649.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7655.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7657.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7658.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7663.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7665.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7683.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7685.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7686.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7691.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7694.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7696.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7697.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7698.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7699.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7700.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7702.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7704.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7707.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7712.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7713.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7714.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7715.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7718.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7721.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7723.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7724.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7725.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7728.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7733.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7735.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7737.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7740.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7743.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7746.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7747.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7748.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7752.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7754.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7759.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7763.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7765.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7768.JPG",
    pathmin: "",
    path: "",
    id: ""
  },
  {
    photo: "055A7770.JPG",
    pathmin: "",
    path: "",
    id: ""
  }
];
export { _fotos_cies_2019 };
